
export type MarkNotificationAsFailed200Status = {
  isRead: boolean;
};
